import React from 'react'
import { useStyles } from './style'
import { Box, Typography, useMediaQuery } from '@mui/material'
import { LockTwoTone } from '@mui/icons-material'
import { GooglePayLogo, ApplePayLogo, PayPalLogo } from '../../../../logos'
import CardsLogo from '../../../../logos/cards.png'
import { PrivacyPolicyLink, TandCLink } from '../../../../policy-links'
import PaywallCarousel from './carousel'
import PaywallLaurelWreath from './laurelWreath'

const PaywallTrustAndPartners = () => {
  const classes = useStyles()
  // The Exclusive Content Paywall requires a different breakpoint for mobile
  // Any changes to this value should also be reflected in the style.js file
  const isMobile = useMediaQuery('(max-width:967px)')

  return (
    <Box className={classes.trust} data-test='paywall-trust-container'>
      {!isMobile && (
        <Box className={classes.partners} data-test='paywall-trust-partners'>
          <PaywallLaurelWreath />
          <PaywallCarousel />
        </Box>
      )}
      {!isMobile && (
        <Box className={classes.payment} data-test='paywall-trust-payment-options'>
          <Box sx={{ minWidth: '180px' }} data-test='paywall-trust-payment-options-description'>
            <Typography fontWeight='bold'>
              Cancel Online Anytime.
            </Typography>
            <Box className={classes.paymentDetails}>
              <LockTwoTone fontSize='0.75rem' />
              <Typography variant='caption' lineHeight='0.75'>
                Backed by secure global payment systems
              </Typography>
            </Box>
          </Box>
          <Box className={classes.paymentOptions} data-test='paywall-trust-payment-options-logos'>
            <Box className={classes.paymentLogo} padding={1.5} data-test='paywall-trust-payment-options-logos-google-pay'>
              <GooglePayLogo />
            </Box>
            <Box className={classes.paymentLogo} padding={1.5} data-test='paywall-trust-payment-options-logos-apple-pay'>
              <ApplePayLogo />
            </Box>
            <Box className={classes.paymentLogo} padding={0.5} data-test='paywall-trust-payment-options-logos-paypal'>
              <PayPalLogo />
            </Box>
            <Box backgroundColor='grey.200' borderRadius={1} height='30px' width='100px' data-test='paywall-trust-payment-options-logos-credit-cards'>
              <img src={CardsLogo} alt='Credit cards' />
            </Box>
          </Box>
        </Box>
      )}
      <Box className={classes.policies} data-test='paywall-trust-policies'>
        <Typography data-test='paywall-trust-policies-text-links'>
          <PrivacyPolicyLink style={{ color: 'white', textDecoration: 'underline' }} /> and <TandCLink style={{ color: 'white', textDecoration: 'underline' }}> Terms and Conditions </TandCLink>
        </Typography>
      </Box>
    </Box>
  )
}

export default PaywallTrustAndPartners
